import { Trans } from 'next-i18next';
import Link from 'next/link';
import CallToActionContainer from '@/components/common/callToAction/CallToActionContainer';
import Icon from '@/components/common/iconedLinks/Icon';

import styles from './RestrictedArea.module.scss';
import { URLS } from '@/constants/urls';

type RestrictedAreaProps = {
  showButton: boolean;
  buttonText: string;
  onButtonClick: () => void;
  isButtonFullWidth?: boolean;
}

const RestrictedArea = (props: RestrictedAreaProps): React.JSX.Element => {
  const { showButton = false, buttonText, onButtonClick, isButtonFullWidth = false } = props;

  return (
    <div className={styles['restricted-area']} data-test-id="restricted-area" data-rbf="restricted-area">
      <div className={styles['content']}>
        <Icon src={URLS.ICON_INFO_HELP} alt="info-help" />
        <span data-test-id="restricted-area-content">
          <Trans i18nKey={'restricted.exclusiveCellar'}
            components={{
              PremiumLink: <Link href="/premium.html" passHref><a/></Link>,
              ContactLink: <Link href="/contact.html" passHref><a/></Link>
            }}
          />
        </span>
      </div>
      {showButton &&
        <CallToActionContainer onClick={onButtonClick} fullWidth={isButtonFullWidth}>{buttonText}</CallToActionContainer>
      }
    </div>
  );
};

export default RestrictedArea;
